import {GeographicLabels} from '../lib/geographic-labels.js';
import {is3DView} from '../lib/camera-state.js';
import {state as stationsState} from './stations.js';
import {isInterpolationEnabled} from './interpol.js';

export function referenceVisibility(interpolation,stationsVisible,terrain){
 const enabled=Boolean(interpolation&&!stationsVisible);
 return {enabled,terrain:enabled&&Boolean(terrain)};
}
export function initGeographicReferences(map){
 const labels=new GeographicLabels(map,{peaksUrl:'/v2/assets/data/relief-peaks.json'});
 let ready=false,loading=null,removed=false;
 const state=()=>referenceVisibility(isInterpolationEnabled(),stationsState.options.visible,is3DView(map));
 const sync=()=>{
  if(removed)return;
  const wanted=state();
  if(ready){labels.update(wanted);return;}
  if(!wanted.enabled||loading)return;
  loading=fetch('/v2/assets/data/geographic-places.json').then(r=>{if(!r.ok)throw Error('Località non disponibili');return r.json();}).then(places=>{
   if(removed)return;
   if(!map.getStyle().glyphs)map.setGlyphs('https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf');
   labels.setPlaces(places);ready=true;labels.update(state());
  }).catch(error=>{loading=null;if(!removed)console.warn('Riferimenti geografici:',error.message);});
 };
 const events=['wsv2:interpolation-change','wsv2:stations-visible','wsv2:viewchange'];
 const changedControl=event=>{if(['chkMarkers','chkInterpol'].includes(event.target?.id))sync();};
 document.addEventListener('change',changedControl);
 for(const event of events)document.addEventListener(event,sync);
 map.on('styledata',sync);
 map.on('remove',()=>{removed=true;for(const event of events)document.removeEventListener(event,sync);document.removeEventListener('change',changedControl);map.off('styledata',sync);});
 sync();
 return {sync};
}
